<template>
    <footer class="footer m-t-md">
        <div class="container">
            <h3 class="n-m-t p-t-sm">合作伙伴</h3>
            <div class="row partners">
                <div class="col-xs-12 col-sm-4 col-md-3  m-b-sm text-center partner">
                    <a href="http://www.psych.cas.cn" title="中国科学院心理研究所" alt="中国科学院心理研究所" rel="nofollow" target="_blank"><img src="/assets/images/psych2_03.jpg" alt="" class="logo"></a>
                </div>
                <div class="col-xs-12 col-sm-4 col-md-3  m-b-sm text-center partner">
                    <a href="http://www.lechenggu.com" title="乐橙谷" alt="乐橙谷" rel="nofollow" target="_blank"><img src="/assets/images/lechenggu-logo.png" alt="" class="logo"></a>
                </div>
                <div class="col-xs-12 col-sm-4 col-md-3  m-b-sm text-center partner">
                    <a href="http://www.litsoft.com.cn" title="联和利泰" alt="联和利泰" rel="nofollow" target="_blank"><img src="/assets/images/litsoft-logo.png" alt="" class="logo"></a>
                </div>
                <div class="col-xs-12 col-sm-4 col-md-3  m-b-sm text-center partner">
                    <a href="https://www.lenovo.com.cn" title="联想集团" alt="联想集团" rel="nofollow" target="_blank"><img src="/assets/images/lenovo-logo.jpg" alt="" class="logo"></a>
                </div>
            </div>
            <div class="row m-t-sm p-t-b-sm desc">
                <div class="text-center m-b-xs">Copyright © {{cr_text}} {{global.name}}. 当前版本 {{global.version}}</div>
                <div class="text-center m-b-xs">{{global.icp}} 北京华宇互联科技有限公司版权所有</div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
    data: function () {
        return {
            start: 2016,
            end: 2017,
            cr_text: '2017'
        }
    },
    created: function () {
        const that = this
        let d = new Date()
        let end = d.getFullYear()
        if (end != that.start) {
            that.cr_text = `${that.start}-${end}`
        }
    }
}
</script>




// WEBPACK FOOTER //
// footer.vue?60d16868